import { ApiService } from '../../app-lite/api/api.service';

import AdjustVehicleGroupsHtml from './vehicle-groups.adjust.html';
import ManageVehicleTypesHtml  from './vehicle-types.manage.html';

export function VehicleGroupsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'AdjustVehicleGroupsCtrl',
    name       : 'app.adjust-vehicle-groups',
    templateUrl: AdjustVehicleGroupsHtml,
    url        : '/adjust_vehicle_groups',
    resolve    : {
      groups: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_body_group_types', [0, '*', 'Code', 'asc'])
    }
  })
  .state({
    controller : 'ManageVehicleTypesCtrl',
    name       : 'app.manage-vehicles',
    templateUrl: ManageVehicleTypesHtml,
    url        : '/manage_vehicles',
    resolve    : {
      body_types: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_body_types', [false, 0, '*', 'Code', 'asc']),
      groups    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vehicle_body_group_types', [0, '*', 'Code', 'asc'])
    }
  });
}